export default __webpack_public_path__ + "555e49f.png";